import React, { Component } from "react";
import { connect } from "react-redux";
import { Field, reduxForm, formValueSelector } from "redux-form";
import { CustomCheckbox } from "components/Controls";
import {
  loadingSelector,
  activeStepDataSelector,
} from "containers/MultistepForm/selectors";
import { nextStep } from "containers/MultistepForm/actions";
import { required } from "utils/validations";

import "../ApprovedScreen/styles.scss";

const selector = formValueSelector('kafene_contract_form');

class KafeneContractView extends Component {
  state = {
    blobUrl: null,
    error: null,
    valid: false,
  };

  iframeRef = React.createRef();

  componentDidMount() {
    const { offer } = this.props;
    this.checkInitialValidity();
    
    if (offer.contract_pdf) {
      try {
        const base64String = offer.contract_pdf.replace(/\s/g, '');
        const byteCharacters = atob(base64String);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: "application/pdf" });
        const blobUrl = URL.createObjectURL(blob);
        this.setState({ blobUrl });
      } catch (error) {
        console.error("Error decoding contract PDF:", error);
        this.setState({ error: "Unable to display the contract. The document may be corrupted." });
      }
    } else {
      this.setState({ error: "Contract is not available." });
    }
  }

  componentWillUnmount() {
    if (this.state.blobUrl) {
      URL.revokeObjectURL(this.state.blobUrl);
    }
  }

  checkInitialValidity = () => {
    const { isAgreementChecked } = this.props;
    const valid = !!isAgreementChecked;
    this.setState({ valid });
  };

  handleChange = () => {
    const { isAgreementChecked } = this.props;
    const valid = !!isAgreementChecked;
    this.setState({ valid });
  };

  renderCheckbox = ({ input, meta }) => {
    return (
      <CustomCheckbox className="checkbox" meta={meta} {...input} customChange={this.handleCheckboxChange} />
    );
  };

  handleCheckboxChange = () => {
    const { isAgreementChecked, offer, nextStep } = this.props;
    this.handleChange();
    
    if (isAgreementChecked) {
      nextStep({
        step: "kafeneStripePayment",
        data: offer,
      });
    }
  };

  render() {
    const { loading, valid } = this.props;
    const { blobUrl, error, valid: stateValid } = this.state;

    const isCheckboxDisabled = loading || !!error;

    return (
      <div style={{ maxWidth: '900px', margin: '0 auto', padding: '40px 20px', textAlign: 'center' }}>
        <h1 className="kafene-approved-screen__title">Review Your Lease Agreement</h1>
        <p className="kafene-approved-screen__subtitle">
          Please review the contract below before proceeding to payment.
        </p>

        {error && (
          <div style={{
            backgroundColor: '#fee',
            border: '1px solid #fcc',
            borderRadius: '4px',
            padding: '16px',
            marginBottom: '20px',
            color: '#c33',
            fontSize: '14px'
          }}>
            {error}
          </div>
        )}

        {blobUrl && !error && (
          <iframe
            ref={this.iframeRef}
            src={blobUrl}
            title="Kafene Lease Agreement"
            style={{ width: "100%", height: "500px", border: "1px solid #ccc", marginBottom: "20px" }}
          />
        )}

        {!error && (
          <>
            <div style={{marginTop: '24px'}}>
              <h2 style={{fontSize: '20px', fontWeight: 600, marginBottom: '16px', textAlign: 'left'}}>Sign the
                Agreement</h2>

              <div className="flex flex__align--baseline" style={{marginBottom: '16px', textAlign: 'start'}}>
                <Field
                  name="isAgreementChecked"
                  validate={[required]}
                  component={this.renderCheckbox}
                  disabled={isCheckboxDisabled}
                />
                By clicking here you are providing your electronic signature and expressly consent to be bound by the terms of the lease.
              </div>
            </div>
          </>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: loadingSelector()(state),
  offer: activeStepDataSelector()(state),
  isAgreementChecked: selector(state, 'isAgreementChecked'),
});

const mapDispatchToProps = (dispatch) => {
  return {
    nextStep: (value) => dispatch(nextStep(value)),
  };
};

KafeneContractView = reduxForm({
  form: 'kafene_contract_form',
  initialValues: { isAgreementChecked: false },
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(KafeneContractView);

KafeneContractView = connect(
  mapStateToProps,
  mapDispatchToProps
)(KafeneContractView);

export default KafeneContractView;
